import { GetterTreeWithRootState } from '~/store/types'
import { DealerSiteErrorType } from '~/models/dealer/site/error/types'
import { DealerSiteErrorState } from './state'

export default {
  errorExists: ({ type }) => (ofType?: DealerSiteErrorType): boolean =>
    Boolean(ofType ? type === ofType : type)
} as GetterTreeWithRootState<DealerSiteErrorState>
